export const socialMediaData = [
    {
        href: 'https://www.instagram.com/studionorcat',
        icon: 'instagram',
    },
    {
        href: 'https://www.youtube.com/channel/UCIE8m9rM9znVklfDHz6f16Q',
        icon: 'youtube',
    },
    {
        href: 'https://x.com/studionorcat',
        icon: 'x-twitter',
    },
];
